import { render, staticRenderFns } from "./DocumentDropdown.vue?vue&type=template&id=9bd59d8c&scoped=true&"
import script from "./DocumentDropdown.vue?vue&type=script&lang=js&"
export * from "./DocumentDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDropdown.vue?vue&type=style&index=0&id=9bd59d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd59d8c",
  null
  
)

/* custom blocks */
import block0 from "./DocumentDropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports